require([
	"jquery",
	"underscore",
	"bootstrap",
	"react",
	"jsx!components/ideas-lab",
	"shared/array-polyfill",
	"shared/pwa-polyfill"
], function ($, _, Bootstrap, React, AppComponent) 
{
	var app = React.createElement(AppComponent);
	React.render(app, document.getElementById('ideas-lab-wrapper'));
}, function (error)
{
	console.log(error);
});
define("init-ideas-lab.js", function(){});

